import { render } from "./ListWhatsappConfigs.vue?vue&type=template&id=5b1dbc96"
import script from "./ListWhatsappConfigs.vue?vue&type=script&lang=js"
export * from "./ListWhatsappConfigs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__